import $ from 'jQuery';

class PasswordProtectedContent {
  constructor(contentUuid) {
    this.contentUuid = contentUuid;

    this.onSubmitPasswordForm = this.onSubmitPasswordForm.bind(this);

    const $form = this.getForm();
    $form.on('submit', this.onSubmitPasswordForm);
  }

  onSubmitPasswordForm(e) {
    e.preventDefault();

    if (this.isPasswordCorrect()) {
      this.removePasswordProtection();
    } else {
      this.showError();
    }
  }

  showError() {
    const message = this.getIncorrectPasswordMessage();
    alert(message);
  }

  getIncorrectPasswordMessage() {
    const $form = this.getForm();
    return $form.attr('data-incorrect-password-message');
  }

  removePasswordProtection() {
    this.hideForm();
    this.showContent();
  }

  hideForm() {
    const $form = this.getForm();
    $form.addClass('hide');
  }

  showContent() {
    const $content = this.getContent();
    $content.removeClass('hide');
  }

  isPasswordCorrect() {
    const inputPassword = this.getPasswordInputValue();
    const password = this.getPassword();

    return password === inputPassword;
  }

  getPasswordInputValue() {
    const $passwordInput = this.getPasswordInput();
    return $passwordInput.val();
  }

  getPasswordInput() {
    const $form = this.getForm();
    return $form.find('[name=password]');
  }

  getPassword() {
    const $form = this.getForm();
    return $form.attr('data-password');
  }

  getForm() {
    return $(`.js-password-form[data-contentuuid=${this.contentUuid}]`);
  }

  getContent() {
    return $(`.js-password-protected[data-contentuuid=${this.contentUuid}]`);
  }
}

$(document).ready(() => {
  $('.js-password-form').each(function () {
    const $form = $(this);
    const contentUuid = $form.attr('data-contentuuid');
    new PasswordProtectedContent(contentUuid);
  });
});
